import { cn } from "@drpcrd/utils/shared";
import { HTMLAttributes } from "react";

/**
 * Skeleton component for displaying loading placeholders. Shows an animated
 * pulse effect to indicate content is loading.
 *
 * @example
 * ```tsx
 * <Skeleton className="h-12 w-12 rounded-full" />
 * ```
 */
export const Skeleton = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn("animate-pulse rounded-md bg-neutral-500/75", className)}
    {...props}
  />
);
